import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  careerIdeas: [],
  connections: []
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/quest/vuex/index.js